import React from "react";
import { Plus } from "lucide-react";

const services = [
  "Marketing Planning and Communications Strategy",
  "Brand Definition & Style Sheet Development",
  "Copyediting & Content Development",
  "DEI Communications and Translation Services",
  "Digital Marketing",
  "Graphic Design",
  "Logos",
  "Promotional Items",
  "Public Relations",
  "SEO",
];

export const SupplementalServices = () => {
  return (
    <section
      id="supplemental"
      className="section-divider radio-waves relative"
      style={{ "--rw-x": "100%", "--rw-y": "50%" }}
      data-testid="supplemental-section"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
              Supplemental Services
            </h2>
            <p className="mt-6 text-[16px] md:text-[17px] leading-[1.75] text-[color:var(--bpm-cream-soft)] max-w-md">
              Email marketing is just one part of a successful outreach
              strategy. Need more help? We also offer:
            </p>
          </div>

          <ul
            className="lg:col-span-7 columns-1 sm:columns-2 gap-x-8"
            data-testid="supplemental-list"
          >
            {services.map((s, i) => (
              <li
                key={s}
                className={`flex items-start gap-3 py-1${i === 4 ? " sm:break-after-column" : ""}`}
                style={{ breakInside: "avoid" }}
                data-testid={`supplemental-item-${i}`}
              >
                <Plus
                  size={16}
                  className="mt-1 shrink-0"
                  style={{ color: "var(--bpm-orange)" }}
                />
                <span className="text-[15px] md:text-[16px] text-[color:var(--bpm-cream)]">
                  {s}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SupplementalServices;
